const states = [{name: "Florida", abbr: "FL"}]

const zipCodes = [
  "33140", "33176", "33180", "33326", "33137", "33158", "33179", "33323", "33056", "33127", "33156", "33322", "33055", "33142", "33143", "33313", "33027", "33166", "33173", "33311", "33010", "33029", "33165", "33301", "33028", "33155", "33178", "33304", "33026", "33141", "33146", "33305", "33025", "33133", "33138", "33306", "33023", "33134", "33150", "33334", "33009", "33145", "33147", "33309", "33013", "33019", "33129", "33319", "33012", "33020", "33068", "33149", "33016", "33021", "33131", "33308", "33018", "33024", "33069", "33130", "33015", "33060", "33135", "33330", "33014", "33062", "33144", "33331", "33054", "33126", "33328", "33351", "33125", "33167", "33314", "33132", "33168", "33312", "33004", "33136", "33161", "33109", "33181", "33315", "33139", "33154", "33316", "33122", "33160", "33317", "33162", "33174", "33324", "33169", "33172", "33325"
]

export default { states, zipCodes }



// WEBPACK FOOTER //
// ./src/common/settings.js